/*****************iOS Safari判定*******************/
document.addEventListener("DOMContentLoaded", () => {
  const ua = navigator.userAgent.toLowerCase();
  const body = document.body;

  if (/iphone|ipad|ipod/.test(ua)) {
    body.classList.add("ios");

    // iOS バージョンを抽出
    const match = ua.match(/os (\d+)_/);
    if (match && match[1]) {
      body.classList.add(`ios${match[1]}`);
    }

    // iOS Safari 判定
    // Chrome for iOS → "crios" が含まれる
    // Firefox for iOS → "fxios" が含まれる
    // Safariのみ → "safari" を含み、かつ crios/fxios を含まない
    if (/safari/.test(ua) && !/crios|fxios/.test(ua)) {
      body.classList.add("safari");
    }
  }
});